// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__t68mA","grow0":"Button_grow0__3LmjB","grow1":"Button_grow1__XpqY5"};